'use client'

import { ClientOnly } from 'components/ClientOnly'
import { AutopilotCompareTable } from 'components/Phantom/_sections/AutopilotCompareTable'
import { AutopilotHero } from 'components/Phantom/_sections/AutopilotHero'
import { AutopilotSteps } from 'components/Phantom/_sections/AutopilotSteps'
import { EnergySavings } from 'components/Phantom/_sections/EnergySavings'
import { PerfectNightSleep } from 'components/Phantom/_sections/PerfectNightSleep'
import { PersonalStewardScroll } from 'components/Phantom/_sections/PersonalStewardScroll'
import { ScrollSequenceStatic } from 'components/Phantom/_sections/ScrollSequenceStatic'
import { Pod4FAQProps } from 'components/Pod4FAQ/types'
import { StickyConnected } from 'components/WebEv/CoverLP2023/Sticky'
import { FC } from 'react'
import { useCurrentRegion } from 'stores/settings'

export const Autopilot: FC<{ faqData: Pod4FAQProps }> = (props) => {
	const currentRegion = useCurrentRegion()
	const { faqData } = props

	const showEnergySavings = currentRegion === '' || currentRegion === 'us'
	return (
		<>
			<StickyConnected />
			<AutopilotHero />
			<ClientOnly>
				<PersonalStewardScroll />
				<PerfectNightSleep />
				<AutopilotSteps />
				{showEnergySavings && <EnergySavings />}
				<AutopilotCompareTable faqData={faqData} />
				<ScrollSequenceStatic />
			</ClientOnly>
		</>
	)
}
